import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NumberModel } from '../../../model/user/number.model';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '../../../shared/services/session.service';
import { MaskUtil } from '../../../shared/utils/star-masking-util';
import { PaymentService } from '../../../shared/services/payment.service';
import { Payment } from '../../../model/payment';
import { PaymentStartStage } from '../../../model/enum/payment.start.stage';
import { MessageService } from '../../../shared/services/message-service';
import { TextService } from '../../../shared/services/text.service';
import { SdkInitText } from '../../../model/user/sdk-init-text';
import { NetmeraService } from "../../../shared/services/netmera-service";
import { OdemePin } from "../../../model/netmera-events/odeme-pin";
import { OdemeSonuc } from "../../../model/netmera-events/odeme-sonuc";
import { Purchase } from "../../../model/netmera-events/purchase";

@Component({
  selector: 'pa-pin',
  templateUrl: './pin.component.html',
  styleUrls: ['./pin.component.scss']
})
export class PinComponent implements OnInit {

  phoneNumber: string;
  submitted = false;
  pinForm = new FormGroup({
    pin: new FormControl('', [Validators.required, Validators.minLength(4)])
  });
  numberModel: NumberModel;
  errorMessage: string;
  payment: Payment;
  textService: TextService;
  trackingId: string;
  merchantCode: string;
  paymentMethodType: string;
  sdkInitTexts: Array<SdkInitText>;

  constructor(private router: Router, private paymentService: PaymentService, private route: ActivatedRoute,
              private sessionService: SessionService, private messageService: MessageService, textService: TextService,
              private netmeraService: NetmeraService, private odemePin: OdemePin, private odemeSonuc: OdemeSonuc, private purchase: Purchase) {
    this.textService = textService;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.trackingId = params.trackingId;
      this.numberModel = new NumberModel();
      this.sessionService.getInitUser(this.trackingId).subscribe(response => {
        if (response != null) {
          this.merchantCode = response?.requestHeader?.merchant?.merchantCode;
          this.payment = response.payment;
          this.sdkInitTexts = response.sdkInitTexts;
          this.phoneNumber = MaskUtil.MaskingConfiguration(response.msisdn, 3, 6);
          this.netmeraService.pushEvent(this.odemePin.setEventObject("PinOdemeEkrani", this.merchantCode));
        }
      }, error => {
        this.router.navigate(['/result/error', this.trackingId]);
      });
    });
  }

  checkPin() {
    this.submitted = true;
    if (this.pinForm.invalid) {
      return;
    }
    this.numberModel.partOfOne = this.pinForm.value.pin;
    this.paymentService.postPaymentPin(this.numberModel, this.trackingId).subscribe(response => {
      this.paymentService.checkPaymentStatus(this.payment, this.trackingId).subscribe(paymentStatusResponse => {
        if (PaymentStartStage.DCB_OTP === paymentStatusResponse.stage) {
          this.router.navigate(['/payment/otp', this.trackingId]);
          return;
        }
        if (PaymentStartStage.THREE_D === paymentStatusResponse.stage) {
          this.router.navigate(['/payment/threeD', this.trackingId], {queryParams: paymentStatusResponse.params});
          return;
        }
        if (PaymentStartStage.NO_PAYMENT === paymentStatusResponse.stage) {
          this.pushPaymentResultEvent("OdemeBasarisiz");
          this.pinForm.reset();
          this.router.navigate(['/payment/selection', this.trackingId]);
          this.messageService.setMessage(paymentStatusResponse.threeDError);
          return;
        }
        if (PaymentStartStage.PAYMENT === paymentStatusResponse.stage) {
          this.paymentService.makePayment(this.payment, this.trackingId).subscribe(paymentResponse => {
            if (PaymentStartStage.PAYMENT_RESULT === paymentResponse.stage) {
              this.pushPaymentResultEvent("OdemeBasarili");
              this.pushPurchaseEvent();
              this.router.navigate(['/result/payment', this.trackingId], {queryParams: paymentResponse.params});
              return;
            }
            if (PaymentStartStage.NO_PAYMENT === paymentResponse.stage) {
              this.pushPaymentResultEvent("OdemeBasarisiz");
              this.pinForm.reset();
              this.router.navigate(['/payment/selection', this.trackingId]);
              this.messageService.setMessage(paymentResponse.threeDError);
              return;
            }
          }, error => {
            this.pushPaymentResultEvent("OdemeBasarisiz");
            this.router.navigate(['/result/error', this.trackingId]);
          });
          return;
        }
      }, error => {
        this.router.navigate(['/result/error', this.trackingId]);
      });
    }, error => {
      if (error.status == 422) {
        this.pinForm.reset();
        this.errorMessage = error.error.message;
      } else {
        this.router.navigate(['/result/error', this.trackingId]);
      }
    });
  }

  pushPurchaseEvent() {
    this.netmeraService.pushEvent(this.purchase.setEventObject(null, null, null,
      null, null, null, Number(this.payment?.amount)/100));
  }

  pushPaymentResultEvent(detay: string) {
    this.netmeraService.pushEvent(this.odemeSonuc.setEventObject(detay, this.merchantCode, this.getPaymentMethodType(), false,
      'PIN', +this.payment?.installment?.count, Number(this.payment?.amount)/100));
  }

  getPaymentMethodType(): string {
    this.paymentMethodType = this.payment?.paymentMethodDTO?.paymentMethodType;
    if (this.paymentMethodType === 'CREDIT_CARD' && this.payment?.paymentMethodDTO?.cardBrand === 'PCARD') {
      this.paymentMethodType = 'PCARD';
    }
    return this.paymentMethodType;
  }

  messageState(value: any) {
    this.errorMessage = value;
  }

}
